import { Link } from "react-router-dom";
import { useJobs } from "@/hooks/use-jobs";
import { StatusBadge } from "@/components/status-badge";
import { formatTokens, relativeTime } from "@/lib/utils";

export function JobsListPage() {
  const { data, isLoading, error } = useJobs();

  return (
    <div className="mx-auto max-w-4xl px-4 py-12">
      <header>
        <Link to="/" className="text-sm text-neutral-500 hover:underline">
          ← Home
        </Link>
        <h1 className="mt-2 text-3xl font-semibold tracking-tight">Your jobs</h1>
      </header>

      {isLoading ? (
        <div className="mt-10 space-y-2">
          {Array.from({ length: 5 }).map((_, i) => (
            <div
              key={i}
              className="h-16 animate-pulse rounded-lg bg-neutral-100 dark:bg-neutral-900"
            />
          ))}
        </div>
      ) : error ? (
        <p className="mt-10 text-sm text-red-500">
          Couldn't load jobs: {(error as Error).message}
        </p>
      ) : (data?.items.length ?? 0) === 0 ? (
        <div className="mt-16 text-center">
          <p className="text-neutral-500">No jobs yet.</p>
          <Link
            to="/catalog"
            className="mt-6 inline-block rounded-lg bg-emerald-500 px-4 py-2 text-sm font-medium text-white hover:bg-emerald-600"
          >
            Browse the catalog →
          </Link>
        </div>
      ) : (
        <ul className="mt-8 divide-y divide-neutral-200 overflow-hidden rounded-xl border border-neutral-200 dark:divide-neutral-800 dark:border-neutral-800">
          {data!.items.map((job) => (
            <li
              key={job.job_id}
              className="flex items-center justify-between bg-white px-5 py-4 text-sm hover:bg-neutral-50 dark:bg-neutral-950 dark:hover:bg-neutral-900"
            >
              <Link
                to={`/jobs/${job.job_id}`}
                className="flex min-w-0 flex-1 items-center gap-4"
              >
                <StatusBadge status={job.status} />
                <div className="min-w-0 flex-1">
                  <p className="truncate font-medium">{job.outcome_id}</p>
                  <p className="truncate text-xs text-neutral-500">
                    {relativeTime(job.created_at)}
                  </p>
                </div>
              </Link>
              <div className="ml-4 shrink-0 text-right">
                {job.captured_amount !== null ? (
                  <span className="text-xs text-neutral-500">
                    −{formatTokens(job.captured_amount)} tokens
                  </span>
                ) : job.status === "failed" || job.status === "cancelled" ? (
                  <span className="text-xs text-neutral-400">refunded</span>
                ) : (
                  <span className="text-xs text-neutral-400">
                    held {formatTokens(job.price_tokens)}
                  </span>
                )}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
